
import React from 'react';

const Tip = ({ children }) => 
  <div className="virison-tv-sticky-tip">
    <span className="virison-tv-sticky-tip-content">{children}</span>
  </div>;

export default Tip;